module.exports = __webpack_public_path__ + "static/unwinding-anxiety-8d7e4b14279dcea587ec6a0d960f2345.webp";